import partyActions from "../Votify/VotifyParty/partyActions";

export const handleRouteError = (history) => {
  return (dispatch) => {
    dispatch({ type: partyActions.NOT_FOUND_PARTY });
    history.replace("/");
  };
};
